import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1.976-7.303L7.805 12.82 7 13.772l3.12 2.639L17 8.838 16.077 8l-6.053 6.697z" fillRule="evenodd" /></svg>);